import type { FC } from 'react'
import { useState } from 'react'

import DataRequestsButton from '@/components/DataRequestsButton'

import Sidebar from './Sidebar'

interface Props {
  customerId: string
  applicationId: string
  subjectId: string
  subjectName?: string
  hasOutcome?: boolean
  disabled?: boolean
}

const DataRequests: FC<Props> = ({
  customerId,
  applicationId,
  subjectId,
  subjectName,
  hasOutcome,
  disabled = false,
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)

  return (
    <>
      {isSidebarOpen && (
        <Sidebar
          customerId={customerId}
          applicationId={applicationId}
          subjectId={subjectId}
          subjectName={subjectName}
          onClose={() => setIsSidebarOpen(false)}
          hasOutcome={hasOutcome}
        />
      )}
      <DataRequestsButton disabled={disabled} onClick={() => setIsSidebarOpen(true)} />
    </>
  )
}

export default DataRequests
